<script lang="ts" setup>
import { useProp } from "@/composables";

interface Action {
  title?: string;
  href: string;
  method: string;
}

defineProps<{ title?: string }>();

const actions = useProp<Action[]>("actions", []);
</script>

<template>
  <div v-if="$page.props.title" class="md:h-9 sm:flex sm:items-center mb-4">
    <div class="sm:flex-auto">
      <p class="font-medium">
        {{ title ?? $page.props.title }}
      </p>
    </div>
    <div class="mt-4 sm:mt-0 sm:ml-16 flex gap-2">
      <template v-for="action in actions">
        <Button
          v-bind="action"
          v-if="action?.hasOwnProperty('when') ? action.when : true"
        >
          {{ action.title }}
        </Button>
      </template>
      <slot></slot>
    </div>
  </div>
</template>
